import { IMedicalState, IGetMedicalArgs, IGetMedicalPayload } from '../types';
import { GET_REPLY } from '../constants';
import medicalServices from '../medicalServices';
import { createAsyncThunk, ActionReducerMapBuilder } from '@reduxjs/toolkit';

export const getReply = createAsyncThunk<any, { id: number }, ThunkAPIConfig>(
  GET_REPLY,
  async (args, { rejectWithValue }) => {
    try {
      const { data } = await medicalServices.getReply(args.id);
      return {
        data
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReplyBuilder = (
  builder: ActionReducerMapBuilder<IMedicalState>
) => {
  const { pending, fulfilled, rejected } = getReply;
  builder
    .addCase(pending, draftState => {
      draftState.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      const { data } = action.payload;
      draftState.loading = false;
      draftState.selectedMedicalReply = data?.data?.result[0];
    })
    .addCase(rejected, draftState => {
      draftState.loading = false;
    });
};
